var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M15.879 1.077a.333.333 0 0 0-.342-.052L.205 7.358a.333.333 0 0 0 .007.618l4.22 1.64c.104.04.221.026.313-.038l5.6-3.982a.333.333 0 0 1 .424.512l-4.666 4.496a.333.333 0 0 0-.102.24v4.488a.333.333 0 0 0 .62.168l2.111-3.616a.167.167 0 0 1 .225-.062l3.884 2.133a.333.333 0 0 0 .486-.221L15.994 1.4a.339.339 0 0 0-.115-.324z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.a3d282ec42ec1011a900f14f50a22a40.svg";
export { ForwardRef as ReactComponent };